<template>
  <el-dialog title="扫码地址前缀管理"
             :visible.sync="visible"
             width="640px"
             append-to-body
             :close-on-press-escape="false"
             @closed="handleClose">
    <el-table border
              :data="list">
      <el-table-column label="地址名称"
                       min-width="140">
        <template slot-scope="{row}">
          <el-input v-model="row.name"
                    :maxlength="20"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="详细地址"
                       min-width="280">
        <template slot-scope="{row}">
          <el-input v-model="row.urlPre"
                    :maxlength="100"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       width="60">
        <template slot-scope="{ $index }">
          <el-button type="text"
                     @click="deleteEmail($index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-button type="primary"
                 :loading="loading"
                 @click="addEmail">添加地址</el-button>
      <el-button :loading="loading"
                 @click="visible = false">取 消</el-button>
      <el-button type="primary"
                 :loading="loading"
                 @click="handleSubmit">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import Commom from '../../../service/common'
export default {
  name: 'url-pre-modal',
  props: {
    k: { type: String, default: '' }
  },
  components: { },
  data () {
    return {
      loading: false,
      visible: false,
      list: [],
      options: { topic: 'zs', k: 'tag_scan_url_pres' }
    }
  },
  methods: {
    init () {
      this.loading = true
      const k = this.k || this.options.k
      Commom.getkeyvaluebykey({ ...this.options, k })
        .then(res => {
          this.loading = false
          const { result, message, v } = res.data
          if (result === 0) {
            console.log(v)
            this.visible = true
            this.list = JSON.parse(v)
          } else if ([13, -13].includes(result)) {
            // 新增
            this.visible = true
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    handleClose () {
      this.list = []
    },
    addEmail () {
      this.list.push({ name: '', urlPre: '' })
    },
    deleteEmail (index) {
      this.list.splice(index, 1)
    },
    handleSubmit () {
      const valid = this.list.every(i => !!i.name && i.urlPre)
      if (valid) {
        this.loading = true
        const k = this.k || this.options.k
        Commom.setkeyvalue({ ...this.options, k, v: JSON.stringify(this.list) })
          .then(res => {
            this.loading = false
            const { result, message } = res.data
            if (result === 0) {
              this.$message.success('设置成功')
            } else {
              this.$message.error(message)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.message)
          })
      }
    }
  }
}
</script>
